import { render, staticRenderFns } from "./items-types.vue?vue&type=template&id=ed13ff64"
import script from "./items-types.vue?vue&type=script&lang=js"
export * from "./items-types.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports